var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAttachment2Icon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_527_114)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.4193 19.0366C7.88594 19.0366 5.83594 16.9866 5.83594 14.4533L5.83594 5.70326C5.83594 3.86159 7.3276 2.36992 9.16927 2.36992C11.0109 2.36992 12.5026 3.86159 12.5026 5.70326V12.7866C12.5026 13.9366 11.5693 14.8699 10.4193 14.8699C9.26927 14.8699 8.33594 13.9366 8.33594 12.7866V6.53659H10.0026V12.8616C10.0026 13.3199 10.8359 13.3199 10.8359 12.8616V5.70326C10.8359 4.78659 10.0859 4.03659 9.16927 4.03659C8.2526 4.03659 7.5026 4.78659 7.5026 5.70326L7.5026 14.4533C7.5026 16.0616 8.81094 17.3699 10.4193 17.3699C12.0276 17.3699 13.3359 16.0616 13.3359 14.4533V6.53659H15.0026V14.4533C15.0026 16.9866 12.9526 19.0366 10.4193 19.0366Z",
    fill: "url(#paint0_linear_527_114)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_527_114",
    x1: 5.83594,
    y1: 19.0366,
    x2: 14.2654,
    y2: 2.00504,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FABB18"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C48E02"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_527_114"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white",
    transform: "matrix(0 -1 1 0 0 20.7036)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAttachment2Icon);
export default __webpack_public_path__ + "static/media/attachment2-icon.69e7e292544ba740195bb659acdeae3a.svg";
export { ForwardRef as ReactComponent };